import styled from 'styled-components'
import { Tooltip } from 'components/atoms'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`

export const Title = styled.span`
  color: ${ (props) => props.theme.colors.standardSchwarz };
`

export const Icon = styled.div`
  position: relative;
  color: ${ (props) => props.theme.colors['aok-gruen'] };
  top: -1px;

  :hover {
    cursor: pointer;
  }
`

export const WordHintsTooltip = styled(Tooltip)`
  margin-left: 10px;
  position: relative;
  top: 2px;
`
